import axios from 'axios';
import { getStoredJson } from '../utils/storage';
import { normalizeApiError } from './apiError';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

const isApiEnvelope = (data) =>
  data &&
  typeof data === 'object' &&
  Object.prototype.hasOwnProperty.call(data, 'success') &&
  Object.prototype.hasOwnProperty.call(data, 'message') &&
  Object.prototype.hasOwnProperty.call(data, 'data');

httpClient.interceptors.request.use((config) => {
  const user = getStoredJson('user');
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => {
    window.dispatchEvent(new CustomEvent('server:up'));

    if (response.config?.responseType === 'blob') {
      return response;
    }

    if (isApiEnvelope(response.data)) {
      response.apiEnvelope = response.data;
      response.data = response.data.data;
    }

    return response;
  },
  (error) => {
    const status = error.response?.status;
    // No response = server unreachable; 5xx = server/DB error
    const isDown = (!error.response && error.request) || (status >= 500);
    window.dispatchEvent(new CustomEvent(isDown ? 'server:down' : 'server:up'));
    error.apiError = normalizeApiError(error);
    return Promise.reject(error);
  }
);

export const requestData = async (request) => {
  const response = await request;
  const payload = response.data;

  if (
    payload &&
    typeof payload === 'object' &&
    !Object.prototype.hasOwnProperty.call(payload, 'data')
  ) {
    Object.defineProperty(payload, 'data', {
      value: payload,
      enumerable: false,
      configurable: true,
    });
  }

  return payload;
};

export default httpClient;
